var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19",
    "data-name": "Group 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.282,
    height: 11.108,
    viewBox: "0 0 14.282 11.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 14.282,
    height: 11.108,
    fill: "#e7f0f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8.728,11.108a.793.793,0,0,1-.561-1.354l3.406-3.407H.793a.793.793,0,0,1,0-1.587H11.573L8.167,1.354A.793.793,0,0,1,9.289.233l4.761,4.761a.778.778,0,0,1,.171.256.787.787,0,0,1,0,.609.778.778,0,0,1-.171.256L9.289,10.876a.787.787,0,0,1-.561.233",
    transform: "translate(0 0)",
    fill: "#e7f0f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.4714038d0503db5827287f4b0719e2d0.svg";
export { ForwardRef as ReactComponent };